<!--
    @mousedown.prevent is used to avoid triggering
    `blur` on user click and closing the dropdown
-->

<template>
    <div class="vue-autocomplete">
        <input
            ref="input"
            type="text"
            autocomplete="off"
            :id="name"
            :name="name"
            :placeholder="placeholder"
            :value="query"
            @focus="handleFocus"
            @keydown="handleKeyPress"
            @input="handleInput"
            @blur="handleBlur"
        >

        <transition name="slide">
            <div
                ref="dropdown"
                v-if="isDropdownVisible"
                @mousedown.prevent
                :class="{
                    'vue-dropdown': true,
                    'is-active': isActive
                }"
                :style="{
                    'max-height': dropdownHeight + 'px'
                }"
            >
                <ul>
                    <li
                        v-for="(item, index) in items"
                        :key="item.id"
                        :class="{
                            'vue-dropdown-item': true,
                            'is-selected': selected === index
                        }"
                        @mouseover="selectItem(index)"
                        @click="chooseItem(index)"
                    >
                        <slot name="item" :data="item">
                            {{ item.id }}
                        </slot>
                    </li>
                </ul>
            </div>
        </transition>
    </div>
</template>

<script>
import Dropdown from './Dropdown';

export default {
    extends: Dropdown,
    props: {
        name: {
            type: String
        },
        placeholder: true,
        valueProp: {
            type: String,
            default: 'id'
        }
    },
    data () {
        return {
            query: ''
        };
    },
    computed: {
        isDropdownVisible () {
            return this.isActive && !this.isEmpty;
        }
    },
    methods: {
        close () {
            if (this.isActive) {
                this.isActive = false;

                // Next tick is used because otherwise, the `for` attribute
                // triggers immeidately after the blur and focuses the input again
                this.$nextTick(() => {
                    if (this.$refs.input) {
                        this.$refs.input.blur();
                    }
                });
            }
        },
        handleFocus (event) {
            this.$emit('focus', event);
            this.open();
        },
        handleKeyPress (event) {
            if (event.keyCode === 13) {
                event.preventDefault();
                this.chooseItem();
            } else if (event.keyCode === 38) {
                event.preventDefault();
                this.selectPrevious();
            } else if (event.keyCode === 40) {
                event.preventDefault();
                this.selectNext();
            }
        },
        handleInput (event) {
            this.query = event.target.value;
            this.$emit('input', this.query);
            this.open();
        },
        handleBlur (event) {
            this.$emit('blur', event);
            this.close();
        }
    },
    created () {
        this.$on('selected', function (item) {
            this.query = item[this.valueProp];
        });
    },
    watch: {
        isDropdownVisible (newValue) {
            if (newValue === true) {
                this.$nextTick(this.updateHeight); // nextTick to wait for ref
            }
        },
        query (newValue) {
            this.$emit('change', newValue);
        }
    }
};
</script>
